import React from 'react';
import { motion } from 'framer-motion';
import './FeatureCard.css';

const FeatureCard = ({ 
  icon, 
  title, 
  description, 
  gradient = 'primary',
  onClick,
  delay = 0 
}) => {
  const gradientClass = `gradient-${gradient}`;

  return (
    <motion.div 
      className={`feature-card ${gradientClass}`}
      onClick={onClick}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      whileHover={{ y: -8, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="feature-icon-wrapper">
        <div className="feature-icon">
          {icon}
        </div>
        <div className="feature-icon-bg"></div>
      </div>
      
      <h3 className="feature-title">{title}</h3>
      <p className="feature-description">{description}</p>
      
      <div className="feature-arrow">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </motion.div>
  );
};

export default FeatureCard;
